import { render, staticRenderFns } from "./itineraryComponent.vue?vue&type=template&id=df0c0f1e&scoped=true"
import script from "./itineraryComponent.vue?vue&type=script&lang=js"
export * from "./itineraryComponent.vue?vue&type=script&lang=js"
import style0 from "./itineraryComponent.vue?vue&type=style&index=0&id=df0c0f1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0c0f1e",
  null
  
)

export default component.exports